// нужно подрубить core-js/stable если в сборке нету simplebar
import 'core-js/stable';

import 'url-search-params-polyfill';

// local polyfills
import '@/js/helpers/NodeList.forEach';
import '@/js/helpers/Element.closest';
import '@/js/helpers/Element.remove';
import '@/js/helpers/Element.append';
import '@/js/helpers/Object.entries';

import '@/js/helpers/filters/plural';
import '@/js/helpers/filters/prices';
import '@/js/helpers/jivositeHandler';

import init from '@/js/helpers/init';

import { saveRecoInit } from '@/js/utils/saveRecoProducts';

import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
import PortalVue from 'portal-vue';
import VModal from 'vue-js-modal';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import vClickOutside from 'v-click-outside';
import Tooltip from 'vue-directive-tooltip';
import VueScrollTo from 'vue-scrollto';

import DataLinkToHref from '@/js/widget/DataLinkToHref';

// поддержка IE для Nano ID
if (!window.crypto) {
  window.crypto = window.msCrypto;
}

Vue.use(VueCompositionApi);
Vue.use(PortalVue);
Vue.use(VModal);
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(vClickOutside);
Vue.use(VueScrollTo);
Vue.use(Tooltip, {
  placement: 'top',
  class: 'tooltip-custom',
  offset: 2,
  delay: 100,
});

document.addEventListener('DOMContentLoaded', async () => {
  saveRecoInit();
  init('.js-external-reference', DataLinkToHref, 'widget', 'DataLinkToHref');

  if (document.querySelector('.js-auth-page')) {
    import(/* webpackChunkName: "AuthPage" */'@/js/vue/Auth/AuthPage')
      .then(({ default: AuthPage }) => {
        init('.js-auth-page', AuthPage, 'vue');
      });
  }
});
